let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fP9up")).then(() => parcelRequire('kZxFX'));